export const i18n_namespace = 'service-lights-overview';
